<template>
  <!-- <LazyHydrate when-idle> -->
  <RenderIcon
    :viewBox="viewBox"
    :filter-id="filterId"
    :name="name"
    :size="size"
    :color="color"
    :title="title"
    :desc="desc"
    :shadow="shadow"
  />
  <!-- </LazyHydrate> -->
</template>

<script>
/*
 * https://github.com/ismail9k/use-svg
 */
// import LazyHydrate from 'vue-lazy-hydration'
import RenderIcon from '@library/element/icon/render-icon.vue'
export default {
  name: 'AppIcon',
  components: {
    RenderIcon
    // LazyHydrate,
  },
  props: {
    viewBox: {
      type: String,
      default: '0 0 24 24'
    },
    filterId: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    shadow: {
      type: Object,
      default: () => {
        return {
          dx: '0.0',
          dy: '0.4',
          stdDeviation: '2',
          'flood-opacity': '1'
        }
      }
    }
  }
}
</script>

<style lang="scss">
/* default */
.icon {
  width: 1.2em;
  min-width: 1.2em;
  height: 1.2em;
  min-height: 1.2em;
}

/* sizes */
.icon.is-XXX-large {
  width: 3.75em;
  min-width: 3.75em;
  height: 3.75em;
  min-height: 3.75em;
}
.icon.is-4x-large {
  width: 64px;
  min-width: 64px;
  height: 64px;
  min-height: 64px;

  @screen md {
    width: 108px;
    min-width: 108px;
    height: 108px;
    min-height: 108px;

  }
}
.icon.is-XX-large {
  width: 3.5em;
  min-width: 3.5em;
  height: 3.5em;
  min-height: 3.5em;
}

.icon.is-X-large {
  width: 2.5em;
  min-width: 2.5em;
  height: 2.5em;
  min-height: 2.5em;
}

.icon.is-large {
  width: 2em;
  min-width: 2em;
  height: 2em;
  min-height: 2em;
}

.icon.is-medium {
  width: 1.6em;
  min-width: 1.6em;
  height: 1.6em;
  min-height: 1.6em;
}

.icon.is-normal {
  width: 1.2em;
  min-width: 1.2em;
  height: 1.2em;
  min-height: 1.2em;
}

.icon.is-small {
  width: 1em;
  min-width: 1em;
  height: 1em;
  min-height: 1em;
}

.icon.is-tiny {
  width: 0.8em;
  min-width: 0.8em;
  height: 0.8em;
  min-height: 0.8em;
}

.icon.is-tiny-full {
  width: 0.6em;
  min-width: 0.6em;
  height: 0.6em;
  min-height: 0.6em;
}

.icon.is-star {
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
}
.is-star-v{
  &--small{
    --size:13px;
    width: var(--size);
    height: var(--size);
    max-height: var(--size);
    max-width: var(--size);
    min-height: var(--size);
    min-width: var(--size);
  }
  &--large {
    @screen lg {
      --size:26px;
    }
    --size:13px;
    width: var(--size);
    height: var(--size);
    max-height: var(--size);
    max-width: var(--size);
    min-height: var(--size);
    min-width: var(--size);
  }
}
.tutor-item-star .icon.is-star-v {
  // @apply w-[16px] h-[16px] min-w-[16px] min-h-[16px]  md:w-[18px] md:h-[18px] md:min-w-[18px] md:min-h-[18px];
}

.tutor-avatar-star .icon.is-star-v {
  width: 14px;
  height: 14px;
  max-height: 14px;
  max-width: 14px;
  min-height: 14px;
  min-width: 14px;
  @screen md {
    width: 14px;
    height: 14px;
    max-height: 14px;
    max-width: 14px;
    min-height: 14px;
    min-width: 14px;
  }

  &--large {
    --size: 12px;
    width: var(--size);
    height: var(--size);
    max-height: var(--size);
    max-width: var(--size);
    min-height: var(--size);
    min-width: var(--size);
    @screen md {
      --large-size: 20px;
      width: var(--large-size);
      height: var(--large-size);
      max-height: var(--large-size);
      max-width: var(--large-size);
      min-height: var(--large-size);
      min-width: var(--large-size);
    }
  }
}
</style>
